<template>
  <div class="color-divider"
       :style="{
       'background': color
       }"
  >
  </div>
</template>

<script>
import { SOURCES_COLORS } from '../../constants/sources_data';

export default {
  name: 'ColorDivider',
  props: {
    orderType: {
      type: String,
      default: null,
    },
    orderSource: {
      type: String,
      default: null,
    },
    subscription: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    color() {
      if (this.subscription) {
        return '#00bfff';
      }
      if (this.orderSource && SOURCES_COLORS[this.orderSource]) {
        return SOURCES_COLORS[this.orderSource];
      }
      return 'grey';
    },
  },
};
</script>

<style scoped>
  .color-divider {
    height: 5px;
    border-radius: 2px;
  }
</style>
